import * as React from "react";
import { ConfirmationDialog } from "components/common/ConfirmationDialog";
import { ui } from "components/util/uiHelpers";

export const GidSettingsDeleteConfirmationDialog = ({
    show,
    onClose
}: {
    show: boolean,
    onClose: (deleteDevice?: boolean) => void,
}) => {
    return (
        <ConfirmationDialog
            show={show}
            onClose={onClose}
            title={ui.__("gidSettings.deleteDevice.confirm.title")}
            message={ui.__("gidSettings.deleteDevice.confirm.message")}
            labelOk={ui.__("common.delete")}
        />
    );
};


// WEBPACK FOOTER //
// ./src/components/loginManagement/gidSettings/GidSettingsDeleteConfirmationDialog.tsx